exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-info[data-v-4e7e6e2c]{background:#ecf5ff!important}.text-info[data-v-4e7e6e2c]{color:#409eff!important}", ""]);

// exports
